import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const NoteWithPen: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_29092)'>
        <path
          d='M3.65234 6.70228C3.65234 6.48269 3.83034 6.30469 4.04993 6.30469H12.0017C12.2213 6.30469 12.3993 6.48269 12.3993 6.70228C12.3993 6.92187 12.2213 7.09987 12.0017 7.09987H4.04993C3.83034 7.09987 3.65234 6.92187 3.65234 6.70228Z'
          fill='url(#paint0_linear_12280_29092)'
          stroke='url(#paint1_linear_12280_29092)'
          strokeWidth='0.8'
        />
        <path
          d='M4.04993 8.95312C3.83034 8.95312 3.65234 9.13113 3.65234 9.35072C3.65234 9.5703 3.83034 9.74831 4.04993 9.74831H8.02584C8.24543 9.74831 8.42343 9.5703 8.42343 9.35072C8.42343 9.13113 8.24543 8.95312 8.02584 8.95312H4.04993Z'
          fill='url(#paint2_linear_12280_29092)'
          stroke='url(#paint3_linear_12280_29092)'
          strokeWidth='0.8'
        />
        <path
          d='M3.65234 11.9992C3.65234 11.7796 3.83034 11.6016 4.04993 11.6016H8.02584C8.24543 11.6016 8.42343 11.7796 8.42343 11.9992C8.42343 12.2187 8.24543 12.3967 8.02584 12.3967H4.04993C3.83034 12.3967 3.65234 12.2187 3.65234 11.9992Z'
          fill='url(#paint4_linear_12280_29092)'
          stroke='url(#paint5_linear_12280_29092)'
          strokeWidth='0.8'
        />
        <path
          d='M4.04993 14.2539C3.83034 14.2539 3.65234 14.4319 3.65234 14.6515C3.65234 14.8711 3.83034 15.0491 4.04993 15.0491H8.02584C8.24543 15.0491 8.42343 14.8711 8.42343 14.6515C8.42343 14.4319 8.24543 14.2539 8.02584 14.2539H4.04993Z'
          fill='url(#paint6_linear_12280_29092)'
          stroke='url(#paint7_linear_12280_29092)'
          strokeWidth='0.8'
        />
        <path
          d='M3.65234 17.2999C3.65234 17.0803 3.83034 16.9023 4.04993 16.9023H12.0017C12.2213 16.9023 12.3993 17.0803 12.3993 17.2999C12.3993 17.5195 12.2213 17.6975 12.0017 17.6975H4.04993C3.83034 17.6975 3.65234 17.5195 3.65234 17.2999Z'
          fill='url(#paint8_linear_12280_29092)'
          stroke='url(#paint9_linear_12280_29092)'
          strokeWidth='0.8'
        />
        <path
          d='M4.04993 3.64844C3.83034 3.64844 3.65234 3.82644 3.65234 4.04603C3.65234 4.26562 3.83034 4.44362 4.04993 4.44362H12.0017C12.2213 4.44362 12.3993 4.26562 12.3993 4.04603C12.3993 3.82644 12.2213 3.64844 12.0017 3.64844H4.04993Z'
          fill='url(#paint10_linear_12280_29092)'
          stroke='url(#paint11_linear_12280_29092)'
          strokeWidth='0.8'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.7007 8.11201V21.2771C17.7007 22.2286 16.9294 23 15.9779 23H2.72484C1.77332 23 1.00195 22.2286 1.00195 21.2771V2.72289C1.00195 1.77137 1.77332 1 2.72484 1H15.9779C16.9294 1 17.7007 1.77137 17.7007 2.72289V4.43352L20.4068 1.76746C20.9294 1.25254 21.7729 1.26711 22.2775 1.79964C22.7683 2.31777 22.7542 3.13332 22.2458 3.6341L17.7007 8.11201ZM1.79713 2.72289C1.79713 2.21055 2.21251 1.79518 2.72484 1.79518H15.9779C16.4902 1.79518 16.9056 2.21055 16.9056 2.72289V5.21689L11.8204 10.2267C11.6766 10.3684 11.5589 10.5342 11.4725 10.7166L10.6583 12.4356C10.3855 13.0113 11.0029 13.6026 11.5664 13.3053L13.2008 12.4426C13.3496 12.3641 13.486 12.2643 13.6058 12.1463L16.9056 8.8953V21.2769C16.9056 21.7893 16.4902 22.2046 15.9779 22.2046H2.72489C2.21255 22.2046 1.79718 21.7893 1.79718 21.2769L1.79713 2.72289ZM20.965 2.33403C21.1704 2.13161 21.502 2.1373 21.7003 2.34671C21.8932 2.55034 21.8877 2.87087 21.6878 3.06778L13.0478 11.58C12.9832 11.6436 12.9098 11.6973 12.8297 11.7396L11.5472 12.4164L12.1911 11.0571C12.2377 10.9589 12.3011 10.8696 12.3785 10.7934L20.965 2.33403Z'
          fill='url(#paint12_linear_12280_29092)'
          stroke='url(#paint13_linear_12280_29092)'
          strokeWidth='0.8'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_29092'
          x1='5.46364'
          y1='6.35891'
          x2='5.5047'
          y2='7.26414'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_29092'
          x1='5.46364'
          y1='6.35891'
          x2='5.5047'
          y2='7.26414'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_29092'
          x1='4.64033'
          y1='9.00735'
          x2='4.71524'
          y2='9.90821'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_29092'
          x1='4.64033'
          y1='9.00735'
          x2='4.71524'
          y2='9.90821'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_29092'
          x1='4.64033'
          y1='11.6558'
          x2='4.71524'
          y2='12.5566'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_29092'
          x1='4.64033'
          y1='11.6558'
          x2='4.71524'
          y2='12.5566'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_29092'
          x1='4.64033'
          y1='14.3081'
          x2='4.71524'
          y2='15.209'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_29092'
          x1='4.64033'
          y1='14.3081'
          x2='4.71524'
          y2='15.209'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_29092'
          x1='5.46364'
          y1='16.9566'
          x2='5.5047'
          y2='17.8618'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_29092'
          x1='5.46364'
          y1='16.9566'
          x2='5.5047'
          y2='17.8618'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_29092'
          x1='5.46364'
          y1='3.70266'
          x2='5.5047'
          y2='4.60789'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_29092'
          x1='5.46364'
          y1='3.70266'
          x2='5.5047'
          y2='4.60789'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint12_linear_12280_29092'
          x1='5.48198'
          y1='2.50015'
          x2='15.6081'
          y2='22.4587'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint13_linear_12280_29092'
          x1='5.48198'
          y1='2.50015'
          x2='15.6081'
          y2='22.4587'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_29092'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoteWithPen;
